export const getPinCodeStoreDomain=()=> [

    { value: "Grocery", label: "Grocery" },
    { value: "Food", label: "Food" },
    { value: "Fashion", label: "Fashion" },
    { value: "Electronics", label: "Electronics" },
    { value: "Home Decor", label: "Home Decor" },
    { value: "Pharmacy", label: "Pharmacy" },

]

export const getPinCodeStoreType=(domain)=> {
  const storeTypes = [
    { value: "C7T1VNDB", label: "Supermarket", domain: "Grocery" },
    { value: "CLLFB9UF", label: "Organic & Dry Fruits", domain: "Grocery" },
    { value: "CHELTROZ", label: "Meat & Poultry", domain: "Grocery" },
    { value: "CI548YMP", label: "Fruits & Vegetables", domain: "Grocery" },
    { value: "COZBVOU4", label: "Brand Store", domain: "Grocery" },
    { value: "CEWM0PQC", label: "Pet Store", domain: "Grocery" },

    { value: "CPSANXFM", label: "Kirana and General Store", domain: "Grocery" },
    { value: "CFZJDXAN", label: "Spice and Condiment Store", domain: "Grocery" },
    { value: "CJV2X1SC", label: "Dairy Shop", domain: "Grocery" },
    { value: "CMM3TNXH", label: "Stationery and Book Store", domain: "Grocery" },

    { value: "CZMQ8MCQ", label: "Sweet Shop", domain: "Food" },
    { value: "C882XMAR", label: "Cakes & Bakery", domain: "Food" },
    { value: "CU0V6HY8", label: "Bakery", domain: "Food" },
    { value: "CQHAFXBO", label: "Cafe", domain: "Food" },
    { value: "CKEA0YUY", label: "Quick Bites", domain: "Food" },
    { value: "CD5TKAXS", label: "Budget Eats", domain: "Food" },
    { value: "CWEZYP1B", label: "Casual Dining", domain: "Food" },
    { value: "CZKDDJRQ", label: "Fine Dining", domain: "Food" },
    { value: "C2JIZFKY", label: "Delivery Only", domain: "Food" },
    { value: "C1MR1UOV", label: "Bars, Pubs & Lounge", domain: "Food" },
    { value: "CHBAND8S", label: "Canteen & Mess", domain: "Food" },
    { value: "CUNWOHUO", label: "Desserts and Ice Cream Parlour", domain: "Food" },
    { value: "CMCJI69D", label: "Food Delivery", domain: "Food" },
    { value: "CYWG5MT2", label: "Internet Kitchen", domain: "Food" },
    { value: "CP83HQKS", label: "Fast Food", domain: "Food" },
    { value: "CS7ZTZEE", label: "Juice Corner", domain: "Food" },
    { value: "CHWKFSLQ", label: "Snacks", domain: "Food" },
    { value: "C2VPROVY", label: "Tea Shop", domain: "Food" },

    { value: "CXYNL6KL", label: "Multi-Brand Fashion Store", domain: "Fashion" },
    { value: "CN1JQODL", label: "Fashion Brand Store", domain: "Fashion" },
    { value: "CKPBOIDG", label: "Womens Wear", domain: "Fashion" },
    { value: "CDGDKS5Q", label: "Ready-Made Garment Store", domain: "Fashion" },
    { value: "CBFISVYT", label: "Kids Wear Store", domain: "Fashion" },
    { value: "CJOFNQE7", label: "Fashion Accessories", domain: "Fashion" },
    { value: "C571TN1P", label: "Mens Wear Store", domain: "Fashion" },

    { value: "CMUYLUYQ", label: "Smart Phone Store", domain: "Electronics" },
    { value: "CFPM4DVM", label: "Electronics Store", domain: "Electronics" },
    { value: "CPWXSZJX", label: "Appliances Store", domain: "Electronics" },
    { value: "CNE219BS", label: "Computer Store", domain: "Electronics" },
    {
      value: "CHRUCRZJ",
      label: "Musical Instrument Store",
      domain: "Electronics",
    },

    {
      value: "CDUB4SKA",
      label: "Refurbished Electronics Store",
      domain: "Electronics",
    },
    { value: "CIUNUGIB", label: "Electrical Store", domain: "Electronics" },
    { value: "CEC23CFX", label: "Electronics Brand Store", domain: "Electronics" },
    {
      value: "CC1KJUTD",
      label: "Mobile and Accessories Store",
      domain: "Electronics",
    },

    { value: "C4TIYDUS", label: "Furniture Store", domain: "Home Decor" },
    { value: "CDQUKYD2", label: "Mattress House", domain: "Home Decor" },
    { value: "C5HW4DNF", label: "Gift Shop", domain: "Home Decor" },
    { value: "CDEBJZGI", label: "Furnishing Store", domain: "Home Decor" },
    { value: "C4CJAYRY", label: "Lightnings Store", domain: "Home Decor" },
    { value: "C0F2BHO3", label: "Art & Decor House", domain: "Home Decor" },

    { value: "CDHG3LGK", label: "Kitchenware Store", domain: "Home Decor" },
    { value: "CWRUQ7C4", label: "Carpets and Rugs Shop", domain: "Home Decor" },
    {
      value: "CXAFNS3X",
      label: "Gardenening Supplies Store",
      domain: "Home Decor",
    },
    { value: "CVFQ12MX", label: "Lighting Store", domain: "Home Decor" },
    { value: "C1KZ7O4S", label: "Home Care", domain: "Home Decor" },

    { value: "CADUPK5H", label: "Pharmacy", domain: "Pharmacy" },
    {
      value: "CXX8HTKO",
      label: "Vitamins and Supplements Store",
      domain: "Pharmacy",
    },
    { value: "CERLYHSR", label: "Ayurvedic Pharmacy", domain: "Pharmacy" },
    { value: "CRAFDIUX", label: "Pharmacy Brand Store", domain: "Pharmacy" },
  ];
  return storeTypes.filter((f) => f.domain === domain);
}
